import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { GET_USERS, GET_USER_PROFILE , ADD_NEW_USER , DELETE_USER, UPDATE_USER,  NEXT_PAGE, PREVIOUS_PAGE, FIRST_PAGE, LAST_PAGE, } from "./actionTypes"

import {
  getUsersSuccess,
  getUsersFail,
  getUserProfileSuccess,
  getUserProfileFail,
  addUserFail,
  addUserSuccess,
  updateUserSuccess,
  updateUserFail,
  deleteUserSuccess,
  deleteUserFail,
} from "./actions"

import {
  getUsuarios,
  addUsuario,
  updateUsuario,
  toggleUsuarioStatus,
} from "../../helpers/blopsleads_helper"

function* fetchUsers() {
  try {
    const response = yield call(getUsuarios)
    yield put(getUsersSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* fetchUserProfile() {
  try {
    yield put(getUserProfileSuccess({}))
  } catch (error) {
    yield put(getUserProfileFail(error))
  }
}

function* onUpdateUser({ payload: { user, id } }) {
  try {
    const payload = { name: user.Name, email: user.Email }
    if (user.Perfil) payload.perfil = user.Perfil
    if (user.ParceiroId !== undefined) payload.parceiroId = user.ParceiroId
    const response = yield call(updateUsuario, id, payload)
    yield put(updateUserSuccess(response))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onDeleteUser({ payload: user }) {
  try {
    const response = yield call(toggleUsuarioStatus, user.Id)
    yield put(deleteUserSuccess(response))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onAddNewUser({ payload: user }) {
  try {
    const payload = {
      name: user.Name,
      email: user.Email,
      password: user.Password,
      perfil: user.Perfil || "analista",
    }
    if (user.ParceiroId) payload.parceiroId = user.ParceiroId
    const response = yield call(addUsuario, payload)
    yield put(addUserSuccess(response))
  } catch (error) {
    yield put(addUserFail(error))
  }
}





function* handleNextPage() {
  // lógica para ir à próxima página e buscar os dados da página correspondente
  yield call(fetchUsers);
}

function* handlePreviousPage() {
  // lógica para voltar à página anterior e buscar os dados da página correspondente
  yield call(fetchUsers);
}

function* handleFirstPage() {
  // lógica para ir à primeira página e buscar os dados da página correspondente
  yield call(fetchUsers);
}

function* handleLastPage() {
  // lógica para ir à última página e buscar os dados da página correspondente
  yield call(fetchUsers);
}






function* contactsSaga() {
  yield takeEvery(GET_USERS, fetchUsers)
  yield takeEvery(GET_USER_PROFILE, fetchUserProfile)
  yield takeEvery(ADD_NEW_USER, onAddNewUser)
  yield takeEvery(UPDATE_USER, onUpdateUser)
  yield takeEvery(DELETE_USER, onDeleteUser)

  yield takeEvery(NEXT_PAGE, handleNextPage);
  yield takeEvery(PREVIOUS_PAGE, handlePreviousPage);
  yield takeEvery(FIRST_PAGE, handleFirstPage);
  yield takeEvery(LAST_PAGE, handleLastPage);
}

export default contactsSaga;
